


















































































// Libraries
import { Component, Prop, Watch } from 'vue-property-decorator'
import { mapState } from 'vuex'
import firebase from 'firebase/app'
import _ from 'lodash'
import moment from 'moment'

import { db } from '@/database'

// Mixins
import MatchMixin from '@/mixins/match'

// Sub views
import MatchForm from '@/components/Forms/MatchForm.vue'

const FORM_PICK_ATTRS = ['hName', 'hAbbr', 'vName', 'vAbbr', 'kickoff', 'config.penalties']

@Component({
  components: {
    MatchForm,
  },

  computed: {
    ...mapState('match', ['match']),
  },
})
export default class EditMatchDialog extends MatchMixin {
  @Prop() readonly dialog!: { open: boolean }

  loading = true
  form = null
  errors = {}

  @Watch('dialog.open')
  onOpenChanged(open: boolean): void {
    if (!open) {
      this.form = null
      return
    }

    if (!this.match) {
      this.form = null
    }

    // Pick specific attributes in obj
    // https://lodash.com/docs/4.17.15#pick
    const form = JSON.parse(JSON.stringify(_.pick(this.match, FORM_PICK_ATTRS)))

    // console.log('form', form.config)

    // Convert raw kickoff timestamp to form-friendly parts
    const kickoffObj = form.kickoff as { seconds: number; nanoseconds: number }
    const kickoff = new firebase.firestore.Timestamp(kickoffObj.seconds, kickoffObj.nanoseconds)

    const kickoffMoment = moment(kickoff.toDate())
    // console.log(kickoffMoment)

    form.kickoff = {
      date: kickoffMoment.format('YYYY-MM-DD'),
      time: kickoffMoment.format('HH:mm'),
    }

    form['config.penalties'] = form.config.penalties
    delete form.config

    if (form['config.penalties']) {
      form['config.penalties'].bgActive ??= ''
      form['config.penalties'].bgInactive ??= ''
    }

    this.form = form
    this.loading = false
  }

  save(): void {
    if (!this.match) {
      return
    }

    // console.log('Save match details')

    const match = JSON.parse(JSON.stringify(this.form))

    // Parse kickoff to Javascript Date object
    match.kickoff = moment(match.kickoff.date + ' ' + match.kickoff.time).toDate()

    // Persist updated score to firestore
    db.collection('matches')
      .doc(this.match.id)
      .update(match)
      .then((val: unknown) => {
        // console.log(`Match-details updated!`, val)
        window.flash('Match-details updated!')
        this.dialog.open = false
        return val
      })
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .catch((_e: unknown) => {
        // console.error('Error updating match in firestore', _e)
      })
      .finally(() => {
        this.loading = false
      })
  }

  /**
   * Reset match
   */
  resetMatchState(): void {
    if (!this.match) {
      return
    }

    if (!window.confirm('Are you sure you want to reset match state?')) {
      return
    }

    // console.log('Save match details')

    // Persist updated score to firestore
    db.collection('matches')
      .doc(this.match.id)
      .update({
        hScore: 0,
        vScore: 0,
        gcState: 'PAUSED',
        gcPeriod: 1,
        gcLastValue: 0,
        hPenalties: [],
        vPenalties: [],
      })
      .then(() => {
        // .then((val: unknown) => {
        // console.log(`Match-details updated!`, val)
        window.flash('Match was reset!')
      })
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .catch((_e: unknown) => {
        // console.error('Error updating match in firestore', _e)
      })
      .finally(() => {
        this.loading = false
      })
  }

  /**
   * Delete match
   */
  deleteMatch(): void {
    if (!this.match) {
      return
    }

    if (!window.confirm('Are you sure you want to delete match?')) {
      return
    }

    // console.log('Save match details')

    // Persist updated score to firestore
    db.collection('matches')
      .doc(this.match.id)
      .delete()
      .then(() => {
        // .then((val: unknown) => {
        // console.log(`Match-details updated!`, val)
        window.flash('Match deleted!')

        setTimeout(() => {
          this.$router.push('/')
        }, 2000)
      })
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .catch((_e: unknown) => {
        // console.error('Error updating match in firestore', _e)
      })
      .finally(() => {
        this.loading = false
      })
  }
}
